"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _useRecommendationBusinessSolutions = require("../../../../hooks/recommendation/useRecommendationBusinessSolutions");
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
var _constants = require("../../../../utils/constants");
var _MaacBusinessSolutionTab = _interopRequireDefault(require("./MaacBusinessSolutionTab"));
var _MaacSummarySection = _interopRequireDefault(require("./MaacSummarySection"));
var _RecommendationBusinessSolutionAddOn = _interopRequireDefault(require("../RecommendationBusinessSolutionAddOn"));
var _useQuestionsMetadata = require("../../../../hooks/questionnaire/useQuestionsMetadata");
var _DynamicStarRatingInput = _interopRequireDefault(require("../../../ThemeBasedComponents/DynamicStarRatingInput"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 18px;
  ${_r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)`
      gap: 24px;
    `)}
  ${_r10SourceLibrary.Mixins.respondTo.lg((0, _styledComponents.css)`
      gap: 35px;
    `)}
`;
const MaacBusinessSolutions = () => {
  const shouldShowRatingFeedback = (0, _useConfig.default)('uiSettings.showRecommendationRating', false);
  const recommendationTabsCount = (0, _useConfig.default)('recommendationTabsCount', undefined);
  const displayedProductsOrder = (0, _useConfig.default)('displayedProductsOrder', _constants.DISPLAYED_PRODUCTS_ORDER);
  const {
    flags
  } = (0, _useQuestionsMetadata.useQuestionsMetadata)({});
  const {
    recommendedBusinessSolution,
    premiumBusinessSolution,
    budgetBusinessSolution,
    alternativePremiumBusinessSolution,
    alternativeBudgetBusinessSolution,
    selectedBusinessSolution
  } = (0, _useRecommendationBusinessSolutions.useRecommendationBusinessSolutions)();
  const businessSolutions = (0, _lodash.default)([recommendedBusinessSolution, premiumBusinessSolution, budgetBusinessSolution, alternativePremiumBusinessSolution, alternativeBudgetBusinessSolution].sort((product1, product2) => {
    return displayedProductsOrder.indexOf(product1 === null || product1 === void 0 ? void 0 : product1.tier) - displayedProductsOrder.indexOf(product2 === null || product2 === void 0 ? void 0 : product2.tier);
  }).filter(businessSolution => !!businessSolution).slice(0, isNaN(recommendationTabsCount) ? undefined : recommendationTabsCount), p => p.productId);
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_MaacBusinessSolutionTab.default, {
    businessSolutions: businessSolutions,
    selectedBusinessSolution: selectedBusinessSolution
  }), flags.addon && /*#__PURE__*/_react.default.createElement(_RecommendationBusinessSolutionAddOn.default, {
    selectedBusinessSolution: selectedBusinessSolution
  }), shouldShowRatingFeedback && /*#__PURE__*/_react.default.createElement(_DynamicStarRatingInput.default, {
    starsPadding: "9px",
    starsScale: "1.3"
  }), /*#__PURE__*/_react.default.createElement(_MaacSummarySection.default, null));
};
var _default = MaacBusinessSolutions;
exports.default = _default;